import * as React from 'react';
import { useState, Fragment, useEffect } from "react";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
import OutputIcon from '@mui/icons-material/Output';
import Grid from "@mui/material/Grid";
import { Typography, Divider } from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import { addCardsFromSaveWordsApi } from "../../../../../../services/leitnerApi"

export default function TransferWords(props) {
  const { selectedLeitner, selectedWords, selectedGroup, handleSelectWords, handleTransferDone } = props
  // - اگر کاربر انتقال لغات را بر اساس لغت انجام دهد تمامی لغات ارسالی از فرانت پس از ذخیره در سرویس لایتنر از سرویس ذخیره لغت (usersavewords) حذف می شود ("deletedWords":false)
  // - اما اگر بر اساس نام گروه لغات را انتخاب کند  لغت ذخیره شده در سرویس ذخیره لغت (usersavewords) ویرایش شده و نام گروه از داخل آن حذف می گردد  ("deletedWordsId":{"groupName":"selectedGroup","ids":[]})
  // - در حقیقت deletedWordsId فقط در زمان انتقال از نوع گروه دارای مقدار است که درون آن تمامی آی دی ها بهمراه با نام گروه قرار دارند و باعث می شود لغات با این آی  ها ویرایش گردند و نام گروه از درون آنها حذف شود
  const [transferInfo, setTransferInfo] = React.useState({ wordsCount: "---", leitnerName: "---" });
  const [loading, setLoading] = React.useState(false);
  const [doneSendWords, setDoneSendWords] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [msg, setMsg] = React.useState("");
  // const timer = React.useRef();

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  };


  useEffect(() => {
    // console.log("1234560,", selectedLeitner)
    // console.log("1234560,", selectedWords)
    if (selectedGroup) setTransferInfo({ wordsCount: selectedWords.length, leitnerName: selectedLeitner["name"], groupName: selectedGroup })
    else setTransferInfo({ wordsCount: selectedWords.length, leitnerName: selectedLeitner["name"] })
    // return () => {
    //   clearTimeout(timer.current);
    // };
  }, []);

  const ckeckWordsGroup = () => {
    let ids = []
    selectedWords.forEach((word) => {
      if (word["groups"].length == 1) ids.push({ userId: word["userId"], _id: word["_id"] })
    })
    return { groupName: selectedGroup, ids }
  }
  const handleButtonClick = async () => {
    // console.log("selectedLeitner,", selectedLeitner)
    // console.log("selectedWords,", selectedWords)

    if (selectedWords.length == 0) setMsg("لطفا لغاتی را برای انتقال انتخاب کنید")
    else {
      if (!loading && !doneSendWords) {
        setSuccess(false);
        setLoading(true);
        setDoneSendWords(true);
        let deletedWords = false
        if (selectedGroup) deletedWords = ckeckWordsGroup()
        // console.log("deletedWordsIddeletedWordsId",deletedWords)
        let data = { boxId: selectedLeitner["id"], cards: selectedWords, deletedWords }
        let response = await addCardsFromSaveWordsApi(data)
        // console.log(response)
        handleTransferDone(true)
        setMsg(`انتقال ${selectedWords.length} لغت با موفقیت انجام شد`)
        handleSelectWords([])
        setSuccess(true);
        setLoading(false);
      }
    }
  };

  return (
    <Box id="amirrr5" sx={{
      height: "73%",
      width: "100%",
      p: 1,
      textAlign: "center",
    }}>
      <Typography sx={{ color: (theme) => theme.palette.reverse.dark, }}>
        {`تعداد لغت:  ${transferInfo["wordsCount"]}`}
      </Typography>
      {selectedGroup ? <Typography>
        {`نام گروه: ${transferInfo["groupName"]}`}
      </Typography> : null}
      <Typography>
        {`نام لایتنر: ${transferInfo["leitnerName"]}`}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: "center", alignItems: 'center', }}>
        <Box sx={{ m: 1, position: 'relative' }}>
          <Button
            variant="contained"
            sx={buttonSx}
            disabled={loading}
            onClick={handleButtonClick}
            endIcon={success ? <CheckIcon /> : <OutputIcon />}
          >
            انتقال به لایتنر
          </Button>
          {success ? <Typography>
            {msg}
          </Typography> : null}
          {loading && (
            <CircularProgress
              size={24}
              sx={{
                color: green[500],
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-12px',
                marginLeft: '-12px',
              }}
            />
          )}
        </Box>
      </Box>
      <Box sx={{ width: '100%' }}>
        {loading ? <LinearProgress /> : null}
      </Box>
    </Box>
  );
}